import { createAsyncThunk } from "@reduxjs/toolkit"
import {
  del,
  formDataPost,
  formDataPut,
  get,
  patch,
  post,
} from "helpers/api_helper"
import {
  ADD_ALLERGEN,
  DELETE_ALLERGEN,
  GET_ALLERGEN_DETAILS,
  GET_ALL_ALLERGEN,
  GET_ALL_ALLERGENS_LIST,
  UPDATE_ALLERGEN,
  UPDATE_ALLERGEN_STATUS,
} from "helpers/url_helper"

export const getAllergensList = createAsyncThunk(
  GET_ALL_ALLERGENS_LIST,
  async payload => {
    const response = await get(GET_ALL_ALLERGENS_LIST, payload)
    return response
  }
)

export const getAllergens = createAsyncThunk(
  GET_ALL_ALLERGEN,
  async payload => {
    const response = await post(GET_ALL_ALLERGEN, payload)
    return response
  }
)

export const updateAllergenStatus = createAsyncThunk(
  UPDATE_ALLERGEN_STATUS,
  async payload => {
    const response = await patch(UPDATE_ALLERGEN_STATUS, payload)
    return response
  }
)

export const deleteAllergen = createAsyncThunk(
  DELETE_ALLERGEN,
  async payload => {
    const response = await del(DELETE_ALLERGEN, payload)
    return response
  }
)

export const addAllergen = createAsyncThunk(ADD_ALLERGEN, async payload => {
  const response = await formDataPost(ADD_ALLERGEN, payload)
  return response
})

export const updateAllergen = createAsyncThunk(
  UPDATE_ALLERGEN,
  async payload => {
    const response = await formDataPut(UPDATE_ALLERGEN, payload)
    return response
  }
)

export const getAllergenDetails = createAsyncThunk(
  GET_ALLERGEN_DETAILS,
  async payload => {
    const response = await post(GET_ALLERGEN_DETAILS, payload)
    return response
  }
)
